import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { styles } from './styles';

const LoaderButton = ({ children, loading, circleColor = 'primary', circleSize = 24, ...rest }) => {
	return (
		<Button disabled={loading} {...rest}>
			{children}
			{loading && <CircularProgress color={circleColor} size={circleSize} sx={styles.loader} />}
		</Button>
	);
};

export default LoaderButton;
